module.exports = __webpack_public_path__ + "cement/img/编组 39@2x.5db54dee.png";